import Clipboard from 'clipboard'
import ReactTooltip from 'react-tooltip'
import axios from 'axios'
import React from 'react'
import PropTypes from 'prop-types'
import FormInput from './FormInput'
import Spinner from './Spinner'
import ShareButton from './ShareButton'
import Alert from './Alert'

class Refer extends React.Component {
  constructor(props) {
    super(props)
    this.collapse = this.collapse.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.resetState = this.resetState.bind(this)
    this.state = {
      error: '',
      loading: false,
      referCodeClassname: 'show',
      referManualClassname: null,
      refer: {
        name: {
          value: '',
          validation: '',
        },
        companyName: {
          value: '',
          validation: '',
        },
        phone: {
          value: '',
          validation: '',
        },
        email: {
          value: '',
          validation: '',
        },
      },
    }
  }
  handleClipboard() {
    // manage copy to clipboard
    const clipboard = new Clipboard('#copy', { target: document.getElementById('referralLink') })
    clipboard.on('success', (e) => {
      console.info('Action:', e.action) // eslint-disable-line no-console
      console.info('Text:', e.text) // eslint-disable-line no-console
      console.info('Trigger:', e.trigger) // eslint-disable-line no-console
      ReactTooltip.show(this.refs.foo) // eslint-disable-line react/no-string-refs
      setTimeout(() => {
        ReactTooltip.hide(this.refs.foo) // eslint-disable-line react/no-string-refs
      }, 3000)
      e.clearSelection()
    })
  }
  resetState() {
    this.props.onChange()
    this.setState({
      error: '',
      loading: false,
      refer: {
        name: {
          value: '',
          validation: '',
        },
        companyName: {
          value: '',
          validation: '',
        },
        phone: {
          value: '',
          validation: '',
        },
        email: {
          value: '',
          validation: '',
        },
      },
    })
    document.activeElement.blur()
  }
  collapse() {
    if (this.state.referCodeClassname === null) {
      this.setState({
        referCodeClassname: 'show',
        referManualClassname: null,
      })
    } else if (this.state.referCodeClassname === 'show') {
      this.setState({
        referCodeClassname: null,
        referManualClassname: 'show',
      })
    } else if (this.state.referManualClassname === null) {
      this.setState({
        referManualClassname: 'show',
        referCodeClassname: null,
      })
    } else if (this.state.referManualClassname === 'show') {
      this.setState({
        referCodeClassname: null,
        referManualClassname: 'show',
      })
    }
  }
  handleChange(event) {
    let inputValidation
    if (event.target.required && event.target.value === '') {
      inputValidation = 'danger'
    } else if ((event.target.name === 'name' || event.target.name === 'companyName') && event.target.value.length < 3) {
      inputValidation = 'danger'
    } else if (event.target.type === 'password') {
      inputValidation = 'danger'
    } else if (event.target.type === 'tel' && event.target.value.length < 13) {
      inputValidation = 'danger'
    } else if (event.target.type === 'email') {
      const emailRule = /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      if (emailRule.test(event.target.value)) { inputValidation = 'success' } else { inputValidation = 'danger' }
    } else {
      inputValidation = 'success'
    }

    const target = event.target // eslint-disable-line prefer-destructuring
    const inputValue = target.type === 'checkbox' ? target.checked : target.value
    const inputName = target.name
    const refer = this.state.refer // eslint-disable-line prefer-destructuring
    refer[inputName].value = inputValue
    refer[inputName].validation = inputValidation
    this.setState({
      refer,
    })
  }
  handleSubmit(event) {
    event.preventDefault()
    this.setState({ loading: true })
    const that = this
    axios.post('/api/refer', {
      email: that.state.refer.email.value,
      name: that.state.refer.name.value,
      companyName: that.state.refer.companyName.value,
      phone: that.state.refer.phone.value,
      code: that.props.code,
    })
      .then((response) => {
      // update parent element state to trigger reload
        if (response.data.success === false) {
          that.setState({ error: response.data.message, loading: false })
        } else {
          that.resetState()
        }
      })
      .catch(() => {
        that.setState({ error: 'Desculpe, mas estamos enfrentando problemas no nosso servidor. Nossos engenheiros estão trabalhando nisto e as coisas devem voltar ao normal em breve.' })
      })
  }
  theError() {
    if (this.state.error !== '') {
      return (
        <Alert type="danger">
          {this.state.error}
        </Alert>
      )
    }
    return false
  }
  render() {
    return (
      <div>
        <div className="card">
          <div className="card-header list-inline" onClick={this.collapse} tabIndex="0" onKeyPress={this.collapse} role="button" style={{ cursor: 'pointer' }}>
            <h5 className="mb-0 softinBlue-text list-inline-item">
              Compartilhar link de indicação
            </h5>
            <div className={this.state.referManualClassname === null ? 'reduceIconGrey list-inline-item align-middle' : 'expandIconGrey list-inline-item align-middle'} />
          </div>
          <div className={`collapse ${this.state.referCodeClassname}`}>
            <div className="card-block">
              <p>Compartilhe este link com seus parceiros para que eles participem da promoção:</p>
              <div className="d-flex">
                <input id="referralLink" className="form-control inline border-right-0" value={`http://softin.com.br/indique?ref=${this.props.code}`} readOnly />
                <p ref="foo" data-tip="Copiado!"></p> {/* eslint-disable-line react/no-string-refs */}
                <button id="copy" className="btn btn--secondary inline" onClick={this.handleClipboard()} data-clipboard-target="#referralLink">
                  Copiar
                </button>
                <ReactTooltip className="ml-5" place="top" type="dark" effect="float" />
              </div>
              <div className="row no-gutters mt-3">
                <div className="col"><ShareButton link={`https://www.facebook.com/sharer/sharer.php?u=http%3A//softin.com.br/indique?ref=${this.props.code}`} color="#3b5998" icon={require('../assets/img/logos/facebook.svg')} /></div>
                <div className="col"><ShareButton link={`https://twitter.com/home?status=http%3A//softin.com.br/indique?ref=${this.props.code}`} color="#00aced" icon={require('../assets/img/logos/twitter.svg')} /></div>
                <div className="col"><ShareButton link={`https://www.linkedin.com/shareArticle?mini=true&url=http%3A//softin.com.br/indique?ref=${this.props.code}&title=&summary=&source=`} color="#0077b5" icon={require('../assets/img/logos/linkedin.svg')} /></div>
                <div className="col"><ShareButton link={`whatsapp://send?text=http%3A//softin.com.br/indique?ref=${this.props.code}`} color="#25d366" icon={require('../assets/img/logos/whatsapp.svg')} /></div>
              </div>
            </div>
          </div>
        </div>
        <div className="card">
          <div className="card-header list-inline" onClick={this.collapse} tabIndex="0" onKeyPress={this.collapse} role="button" style={{ cursor: 'pointer' }} >
            <h5 className="mb-0 softinBlue-text list-inline-item">
              Indicar manualmente
            </h5>
            <div className={this.state.referManualClassname === null ? 'expandIconGrey list-inline-item align-middle' : 'reduceIconGrey list-inline-item align-middle'} />
          </div>
          <div className={`collapse ${this.state.referManualClassname}`}>
            <div className="card-block">
              {this.theError()}
              <p>Por aqui, você pode nos indicar diretamente os dados de seus parceiros. Desta forma, iremos entrar em contato com eles para oferecer nossos serviços.</p>
              <form onSubmit={this.handleSubmit} id="referForm">
                <FormInput onChange={this.handleChange} value={this.state.refer.name.value} validation={this.state.refer.name.validation} label="Titular" type="text" name="name" />
                <FormInput onChange={this.handleChange} value={this.state.refer.companyName.value} validation={this.state.refer.companyName.validation} label="Nome da empresa" type="text" name="companyName" required />
                <FormInput onChange={this.handleChange} value={this.state.refer.phone.value} validation={this.state.refer.phone.validation} mask="(99) 9999tt999?" formatChars={{ 9: '[0-9]', t: '[0-9]', '?': '[0-9 ]' }} maskChar={null} type="tel" label="Telefone" name="phone" required />
                <FormInput onChange={this.handleChange} value={this.state.refer.email.value} validation={this.state.refer.email.validation} type="email" label="Email" name="email" />
                <button type="submit" className="btn" disabled={(this.state.refer.companyName.validation && this.state.refer.phone.validation) !== 'success' || this.state.refer.email.validation === 'danger'}>Indicar</button>
                {this.state.loading ? <div style={{ float: 'right' }}><Spinner nomargin /></div> : null}
              </form>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Refer.propTypes = {
  onChange: PropTypes.func,
  code: PropTypes.string,
}

export default Refer



// WEBPACK FOOTER //
// ./client/components/Refer.js